<!--
 * @Author: liushumin
 * @Date: 2022-09-06 17:26:40
 * @LastEditTime: 2022-09-30 16:52:35
 * @LastEditors: liushumin
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div class="szOrder">
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item prop="orderNum">
            <el-input
              v-model="filterForm.orderNum"
              placeholder="订单编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="goodsName">
            <el-input
              v-model="filterForm.goodsName"
              placeholder="商品名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="user">
            <el-input
              v-model="filterForm.user"
              placeholder="收货人/电话"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="supplierName">
            <el-input
              v-model="filterForm.supplierName"
              placeholder="供应商名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="brandName">
            <el-input
              v-model="filterForm.brandName"
              placeholder="品牌名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="buyer	">
            <el-input
              v-model="filterForm.buyer"
              placeholder="买家"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="orderSource">
            <el-select
              v-model="filterForm.orderSource"
              placeholder="订单来源"
              class="city-select"
              @change="handleChange"
              style="width: 195px"
              clearable
            >
              <el-option
                v-for="(item, index) in orderList"
                :key="index"
                :label="item.name"
                :value="item.name"
              >
                {{ item.name }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="mode">
            <el-select
              v-model="filterForm.mode"
              placeholder="下单方式"
              class="city-select"
              @change="handleChangePay"
              style="width: 195px"
              clearable
            >
              <el-option
                v-for="(item, index) in sourceList"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
                {{ item.name }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="dateArr"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 300px"
              clearable
              @change="pickerChangeFn()"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilter()">查询</el-button>
            <el-button
              type="primary"
              plain
              icon="el-icon-refresh-right"
              @click="handleReset('filterForm')"
            >
              清空
            </el-button>
          </el-form-item>
        </el-form>
        <div class="order-tab-content">
          <el-tabs v-model="tabCur" @tab-click="handleClick" class="orderTab">
            <el-tab-pane label="全部订单" name="80"></el-tab-pane>
            <el-tab-pane label="待议价" name="10"></el-tab-pane>
            <el-tab-pane label="待付款" name="20"></el-tab-pane>
            <el-tab-pane label="付款核实" name="30"></el-tab-pane>
            <el-tab-pane label="待发货" name="40"></el-tab-pane>
            <el-tab-pane label="已发货" name="50"></el-tab-pane>
            <el-tab-pane label="已完成" name="60"></el-tab-pane>
            <el-tab-pane label="已取消" name="0"></el-tab-pane>
          </el-tabs>
          <div class="plate-order">
            <div class="thead tr">
              <span class="td">商品信息</span>
              <span class="td">订单金额</span>
              <span class="td">买家/收货人</span>
              <span class="td">订单状态</span>
              <span class="td">操作</span>
            </div>
            <div class="order-list" v-if="orderTabList.length > 0">
              <div
                class="item"
                v-for="(item, index) in orderTabList"
                :key="index"
              >
                <div class="top">
                  <span>下单时间:{{ item.createTime }}</span
                  >&nbsp;&nbsp;&nbsp; <span>订单编号:{{ item.orderNum }}</span
                  >&nbsp;&nbsp;&nbsp;
                  <span>订单来源:{{ item.orderSource }}</span
                  >&nbsp;&nbsp;&nbsp;
                  <span>下单方式:{{ item.types | filterPayStatus }}</span>
                </div>
                <table
                  cellspacing="0"
                  cellpadding="0"
                  border="0"
                  style="border-collapse: collapse"
                >
                  <tr class="">
                    <td class="">
                      <div style="display: flex">
                        <!-- <img
                          :src="item.img"
                          alt=""
                          style="
                            width: 100px;
                            height: 100px;
                            display: inline-block;
                            border-radius: 4px;
                          "
                        /> -->
                        <el-image
                          style="
                            width: 100px;
                            height: 100px;
                            display: inline-block;
                            border-radius: 4px;
                          "
                          :src="item.img"
                          :preview-src-list="
                            item.img ? item.img.split(',') : item.img
                          "
                        >
                        </el-image>
                        <div style="padding-left: 20px; flex: 1">
                          <p style="text-align: left">
                            {{ item.productName }}
                          </p>
                          <div style="display: flex">
                            <p style="text-align: left; color: #999999">
                              <span>{{ item.goodsAttribute }}</span
                              ><br /><span>品牌：{{ item.brandName }}</span
                              ><br /><span
                                >供应商：{{ item.supplierName }}</span
                              >
                            </p>
                            <p
                              style="
                                flex: 1;
                                padding-right: 20%;
                                text-align: right;
                              "
                            >
                              <span>{{item.goodsPrice != null ? '￥' + item.goodsPrice : ''}}</span
                              ><br /><span>{{ item.goodsNum != null ? '×' + item.goodsNum : ''}}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="">
                      {{
                        item.totalPrice != null ? "￥" + item.totalPrice : ""
                      }}
                    </td>
                    <td class="">
                      <p>
                        买家：{{
                          item.enterpriseName != null ? item.enterpriseName : ""
                        }}
                      </p>
                      <p>收货人：{{ item.receiver }}{{ item.telphone }}</p>
                    </td>
                    <td class="">{{ item.status | filterStatus }}</td>
                    <td>
                      <div style="display: flex; flex-direction: column">
                        <el-button
                          type="text"
                          size="medium"
                          @click="handleRemark(item.id)"
                        >
                          备注
                        </el-button>
                        <el-button
                          type="text"
                          size="medium"
                          @click="goDetail(item.id, item.status)"
                          style="margin-left: 0px"
                          v-if="
                            item.status == '10' ||
                            item.status == '20' ||
                            item.status == '30' ||
                            item.status == '40' ||
                            item.status == '50' ||
                            item.status == '60' ||
                            item.status == '0'
                          "
                        >
                          查看详情
                        </el-button>
                        <el-button
                          type="text"
                          size="medium"
                          @click="cancelOrder(item.id)"
                          style="margin-left: 0px"
                          v-if="item.status == '10' || item.status == '20'"
                        >
                          取消订单
                        </el-button>
                        <el-button
                          type="text"
                          size="medium"
                          @click="checkLogistics(item.id)"
                          style="margin-left: 0px"
                          v-if="
                            item.status == '50' ||
                            item.status == '60' ||
                            item.status == '0'
                          "
                        >
                          查看物流
                        </el-button>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="order-empty-block" v-else><span>暂无数据</span></div>
          </div>

          <!-- 分页 -->
          <el-pagination
            v-if="orderTabList && orderTabList[0]"
            layout="total, prev, pager, next, jumper"
            :total="total"
            :hide-on-single-page="true"
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            class="order-pagination"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 订单备注弹框 -->
      <remarkDialog
        :openStatus="remarkStatus"
        :orderId="orderId"
        @closeStatus="getCloseStatus"
      ></remarkDialog>

      <!-- 取消订单弹框 -->
      <cancelDialog
        :openStatus="checkStatus"
        :orderId="orderId"
        @closeStatus="getCloseStatus"
      ></cancelDialog>

      <!-- 查看物流弹框 -->
      <logisticsDialog
        :openStatus="logisticsStatus"
        :orderId="orderId"
        @closeStatus="getCloseStatus"
      ></logisticsDialog>
    </div>
  </el-main>
</template>

<script>
import remarkDialog from "./OrderPop/Remark.vue";
import cancelDialog from "./OrderPop/CancelOrder.vue";
import logisticsDialog from "./OrderPop/Logistics.vue";
export default {
  data() {
    return {
      filterForm: {
        orderNum: "",
        goodsName: "",
        orderStatus: "",
        user: "",
        supplierName: "",
        brandName: "",
        buyer: "",
        orderSource: "",
        mode: "",
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10,
      },
      currentPage: 1,
      dateRange: [],
      tabCur: "80",
      expands: [],
      orderList: [
        {
          name: "村集体",
          id: "1",
        },
        {
          name: "合作社",
          id: "2",
        },
      ],
      sourceList: [
        {
          name: "自主下单",
          id: "0",
        },
        {
          name: "运营后台下单",
          id: "1",
        },
      ],
      pagination: {
        page: 1,
        size: 10,
        total: 0,
        loading: false,
      },
      total: 0,
      orderTabList: [],
      remarkStatus: false,
      checkStatus: false,
      logisticsStatus: "",
      orderId: "",
      dateArr: [],
    };
  },
  components: {
    remarkDialog,
    cancelDialog,
    logisticsDialog,
  },
  filters: {
    filterStatus(val) {
      if (val == 10) {
        return "待议价";
      } else if (val == 20) {
        return "待付款";
      } else if (val == 30) {
        return "待确认付款";
      } else if (val == 40) {
        return "待发货";
      } else if (val == 50) {
        return "已发货";
      } else if (val == 60) {
        return "已完成";
      } else if (val == 0) {
        return "已取消";
      }
    },
    filterPayStatus(val) {
      if (val == 0) {
        return "自主下单";
      } else if (val == 1) {
        return "运营后台下单";
      }
    },
  },
  mounted() {
    this.getOrderList();
  },
  methods: {
    handleFilter() {
      this.getOrderList();
    },
    getOrderList() {
      if (this.dateArr != null) {
        if (this.dateArr[0] != undefined) {
          this.filterForm.startTime = this.dateArr[0] + " " + "00:00:00";
        } else {
          this.filterForm.startTime = "";
        }

        if (this.dateArr[1] != undefined) {
          this.filterForm.endTime = this.dateArr[1] + " " + "23:59:59";
        } else {
          this.filterForm.endTime = "";
        }
      }
      this.filterForm.pageNum = this.currentPage;
      this.$http.szOrder.getOrderPage(this.filterForm).then((res) => {
        if (res.status == 1) {
          this.orderTabList = res.data;
          this.total = res.count;
        }
      });
    },
    pickerChangeFn() {
      if (this.dateArr == null) {
        this.filterForm.startTime = "";
        this.filterForm.endTime = "";
      }
    },
    handleChange(val) {
      this.filterForm.orderSource = val;
    },
    handleChangePay(val) {
      this.filterForm.mode = val;
    },
    handleClick(tab) {
      if (tab.name == 80) {
        this.filterForm.orderStatus = "";
      } else {
        this.filterForm.orderStatus = tab.name;
      }
      this.currentPage = 1;
      this.filterForm.pageNum = 1;
      this.getOrderList();
    },
    handleReset() {
      this.filterForm.orderNum = "";
      this.filterForm.goodsName = "";
      this.filterForm.user = "";
      this.filterForm.supplierName = "";
      this.filterForm.brandName = "";
      this.filterForm.buyer = "";
      this.filterForm.orderSource = "";
      this.filterForm.mode = "";
      this.filterForm.endTime = "";
      this.filterForm.startTime = "";
      this.dateArr = [];
      this.$nextTick(() => {
        this.getOrderList();
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getOrderList();
    },
    goDetail(id, status) {
      let path = "/szoperation/order/details";
      this.$router.push({
        path,
        query: {
          id: id,
          orderStatus: status,
          flag: 1,
        },
      });
    },
    // 查看物流信息
    checkLogistics(id) {
      this.orderId = id;
      this.logisticsStatus = true;
    },

    getCloseStatus(val) {
      if (val == true) {
        this.remarkStatus = false;
        this.checkStatus = false;
        this.logisticsStatus = false;
        this.getOrderList();
      }
    },
    // 订单备注
    handleRemark(id) {
      this.remarkStatus = true;
      this.orderId = id;
    },
    // 取消订单
    cancelOrder(id) {
      this.checkStatus = true;
      this.orderId = id;
      s;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../styles/order-global.scss";
</style>
